
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogClosed as ObiThreewayAnalogClosedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-closed.js';
 
 
 

 
 export const ObiThreewayAnalogClosed = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-closed',
   elementClass: ObiThreewayAnalogClosedElement,
   events: {
     
   }
  });
 
 